import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { UserSessionService } from 'src/app/user-session.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService {
  private readonly loginRoute = '/connection';
  private readonly authStorageKeys = [
    'tokenConnectedUserWSU1234567GHTVB',
    'tokenConnectedUserOnline',
    'tokenConnectedCaissieronline',
    'tokenConnectedUserGestionaire',
    'tokenConnectedPartneronline',
    'tokenConnectedPartenaireonline',
    'administratorauthorization',
    'PARTNERROLEIST',
    'inTheRoleOf',
    'refreshToken',
    'usernameThatUserIsNowConnect2345789',
    'securityCodeExistForUser',
    'confirmphoneIsOkForThisUser',
    'confirmCNiIstOkForThisUser'
  ];

  constructor(
    public auth: AuthenticationService,
    public router: Router,
    private userSessionService: UserSessionService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.auth.isAuthenticated()) {
      this.clearAuthSession();
      this.router.navigateByUrl(this.loginRoute);
      return false;
    }

    const user = this.userSessionService.getUser();
    const legacyRole = this.normalizeRole(localStorage.getItem('inTheRoleOf') || '');
    const userRoles = this.normalizeRoles(
      (user?.roles && user.roles.length > 0)
        ? user.roles
        : (legacyRole ? [legacyRole] : [])
    );
    const expectedRoleArray: string[] = this.normalizeRoles(route.data?.['expectedRole'] ?? []);
    const allowUnactivated: boolean = route.data?.['allowUnactivated'] === true;

    if (expectedRoleArray.length > 0) {
      const hasExpectedRole = expectedRoleArray.some(role => userRoles.includes(role));
      if (!hasExpectedRole) {
        this.router.navigateByUrl(this.loginRoute);
        return false;
      }
    }

    if (user?.partnerActivationRequired && !allowUnactivated) {
      this.router.navigateByUrl('/utilisateur/partenaire/activation');
      return false;
    }

    return true;
  }

  private clearAuthSession(): void {
    this.authStorageKeys.forEach((key) => localStorage.removeItem(key));
    this.userSessionService.setUser(null);
  }

  private normalizeRoles(roles: string[] | null | undefined): string[] {
    if (!Array.isArray(roles)) {
      return [];
    }
    return Array.from(new Set(
      roles
        .map(role => this.normalizeRole(role))
        .filter(role => role.length > 0)
    ));
  }

  private normalizeRole(role: string | null | undefined): string {
    if (!role) {
      return '';
    }
    return role.toUpperCase().replace(/^ROLE_/, '').trim();
  }
}
